export const PAGE_THEMES = {
  "/": "theme-welcome",
  "/dashboard": "theme-dashboard",
  "/start": "theme-start",
  "/location": "theme-location",
  "/home-type": "theme-home-type",
  "/lot": "theme-lot",
  "/exterior": "theme-exterior",
  "/interior": "theme-interior",
  "/lifestyle": "theme-lifestyle",
  "/accessibility": "theme-access",
  "/notes": "theme-notes",
  "/tips": "theme-tips",
  "/transaction": "theme-transaction",
  "/complete": "theme-complete",
  "/checklist": "theme-overview",
  "/install": "theme-install",
  "/notices": "theme-notices",
  "/admin": "theme-admin",
  "/login": "theme-start",
  "/register": "theme-start",
  "/seller/login": "theme-seller",
  "/seller/home": "theme-seller",
  "/broker/login": "theme-seller",
  "/broker/dashboard": "theme-seller",
  "/broker/messages": "theme-seller",
  "/broker/messages/archive": "theme-seller",
  "/broker/audit": "theme-seller",
  "/client/messages": "theme-messages",
  "/client/messages/archive": "theme-messages",
  "/seller/welcome": "theme-seller",
  "/seller/property-details": "theme-seller",
  "/seller/interior-features": "theme-seller",
  "/seller/exterior-features": "theme-seller",
  "/seller/upgrades": "theme-seller",
  "/seller/condition-notes": "theme-seller",
  "/seller/photos": "theme-seller",
  "/seller/improvements": "theme-seller",
  "/seller/listing-readiness": "theme-seller",
  "/seller/tips": "theme-seller",
  "/seller/portfolio-summary": "theme-seller",
};

export function pageThemeClass(pathname) {
  if (pathname.startsWith("/manual")) return "theme-overview";
  if (PAGE_THEMES[pathname]) return PAGE_THEMES[pathname];
  if (pathname.startsWith("/admin")) return "theme-admin";
  if (pathname.startsWith("/agent")) return "theme-agent";
  if (pathname.startsWith("/broker")) return "theme-seller";
  if (pathname.startsWith("/client")) return "theme-messages";
  if (pathname.startsWith("/seller")) return "theme-seller";
  return "theme-welcome";
}
